const debug = true;
const wsProtocol = "ws";
const wsDomain = "adm-cms.aksopay.com";
const wsPort = "11216";
const cpDomain = "cashier-pay.aksopay.com";
const cpDomainF = "cashier-cross.aksopay.com";
const title = "AksoSafePay";
const firstName = "Akso";
const lastName = "PAY";
const providerDisplayMerchantOrder = false;
const providerAgentDisplayMerchantOrder = false;
const merchantDisplayProviderOrder = false;
const merchantAgentDisplayProviderOrder = false;
const agentDisplayCreateButton = false;
const merchantCanCancelWithdrawalOrder = true;
const cashierModel = "Cashier";
const icon = "A";
const gcashTitle = "AksoSafe, Inc.";
const formCtrlBtn = "Y";
const orderSTimeBaseDay = 0;
const limitQryDate = "N";
const showQrCode = "Y";
const utcOffset = "+08:00";

export default {
    debug: debug,
    wsProtocol: wsProtocol,
    wsDomain: wsDomain,
    wsPort: wsPort,
    title: title,
    cpDomain: cpDomain,
    cpDomainF: cpDomainF,
    firstName: firstName,
    lastName: lastName,
    providerDisplayMerchantOrder: providerDisplayMerchantOrder,
    providerAgentDisplayMerchantOrder: providerAgentDisplayMerchantOrder,
    merchantDisplayProviderOrder: merchantDisplayProviderOrder,
    merchantAgentDisplayProviderOrder: merchantAgentDisplayProviderOrder,
    agentDisplayCreateButton: agentDisplayCreateButton,
    merchantCanCancelWithdrawalOrder: merchantCanCancelWithdrawalOrder,
    cashierModel: cashierModel,
    icon: icon,
    gcashTitle: gcashTitle,
    formCtrlBtn: formCtrlBtn,
    orderSTimeBaseDay: orderSTimeBaseDay,
    limitQryDate: limitQryDate,
    showQrCode: showQrCode,
    utcOffset: utcOffset,
};
